<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ headerTitle }}</div>
    <div slot="body">
      <a-form
        :form="form.fc"
        v-bind="formItemLayout">
        <a-form-item v-if="!isEdit" :label="$t('network.text_205', [$t('dictionary.project')])" class="mt-3">
          <domain-project
            :fc="form.fc"
            :fd="form.fd"
            :ignoreStorage="true"
            :labelInValue="false"
            :decorators="{ project: decorators.project, domain: decorators.domain }" />
        </a-form-item>
        <a-form-item :label="$t('bastionHost.provider')">
          <base-select
            v-decorator="decorators.provider"
            :options="providerOptions"
            :disabled="isEdit" />
        </a-form-item>
        <a-form-item :label="$t('common_186')">
          <a-input
            v-decorator="decorators.name"
            :placeholder="$t('bastionHost.name.placeholder')" />
        </a-form-item>
        <a-form-item :label="$t('bastionHost.access_url')">
          <a-input
            v-decorator="decorators.access_url"
            :disabled="isEdit"
            :placeholder="$t('bastionHost.access_url.placeholder')" />
        </a-form-item>
        <a-form-item label="Access Key">
          <a-input
            v-decorator="decorators.access_key_id"
            :placeholder="$t('bastionHost.access_key_id.placeholder')" />
        </a-form-item>
        <a-form-item label="Secret Key">
          <a-input
            v-decorator="decorators.access_key_secret"
            :placeholder="$t('bastionHost.access_key_secret.placeholder')" />
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import _ from 'lodash'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import DomainProject from '@/sections/DomainProject'
import { providerOptions } from '../constants'

export default {
  name: 'BastionCreateOrUpdateDialog',
  components: {
    DomainProject,
  },
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      form: {
        fc: this.$form.createForm(this, {
          onValuesChange: (props, values) => {
            Object.keys(values).forEach((key) => {
              this.$set(this.form.fd, key, values[key])
            })
          },
        }),
        fd: {},
      },
      decorators: {
        domain: [
          'domain',
          {
            initialValue: _.get(this.params, 'data[0].domain_id'),
            rules: [
              { validator: true, message: this.$t('rules.domain'), trigger: 'change' },
            ],
          },
        ],
        project: [
          'project',
          {
            initialValue: _.get(this.params, 'data[0].tenant_id') || _.get(this.params, 'data[0].project_id'),
            rules: [
              { validator: true, message: this.$t('rules.project'), trigger: 'change' },
            ],
          },
        ],
        provider: [
          'provider',
          {
            initialValue: 'JumpServer',
          },
        ],
        name: [
          'name',
          {
            rules: [
              { required: true, message: this.$t('bastionHost.name.placeholder') },
            ],
          },
        ],
        access_url: [
          'access_url', {
            validateFirst: true,
            rules: [
              { required: true, message: this.$t('bastionHost.access_url.placeholder') },
              { validator: this.$validate('url'), trigger: ['blur'] },
            ],
          },
        ],
        access_key_id: [
          'access_key_id', {
            rules: [
              { required: true, message: this.$t('bastionHost.access_key_id.placeholder') },
            ],
          },
        ],
        access_key_secret: [
          'access_key_secret', {
            rules: [
              { required: true, message: this.$t('bastionHost.access_key_secret.placeholder') },
            ],
          },
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 18,
        },
        labelCol: {
          span: 6,
        },
      },
      providerOptions,
    }
  },
  computed: {
    isEdit () {
      return this.params?.data?.length > 0
    },
    headerTitle () {
      return this.isEdit ? this.$t('common.action.edit') : this.$t('common_114')
    },
  },
  created () {
    this.manager = new this.$Manager('bastion_hosts')
    this.isEdit && this.initialValue()
  },
  destroyed () {
    this.manager = null
  },
  methods: {
    initialValue () {
      const curObj = this.params.data[0]
      this.$nextTick(() => {
        this.form.fc.setFieldsValue({
          name: curObj.name,
          provider: curObj.provider,
          access_url: curObj.access_url,
          access_key_id: curObj.access_key_id,
        })
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        const values = await this.form.fc.validateFields()
        if (this.isEdit) {
          const curObj = this.params.data[0]
          await this.manager.update({
            id: curObj.id,
            data: {
              ...values,
              domain: values.domain,
              project: values.project,
            },
          })
        } else {
          await this.manager.create({
            data: {
              ...values,
              domain: values.domain,
              project: values.project,
            },
          })
        }
        this.params.success()
        this.cancelDialog()
      } catch (error) {
        throw error
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
